import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SliderQuestion } from '@app/core/models/question/slider-question';

const SHOW_TICKS = 'show-ticks';
const HIDE_TICKS = 'hide-ticks';
const SHOW_LABELS = 'show-labels';
const HIDE_LABELS = 'hide-labels';
const SHOW_TRACK = 'show-track';
const HIDE_TRACK = 'hide-track';

@Component({
  selector: 'app-slider-ticks-labels',
  templateUrl: './slider-ticks-labels.component.html',
  styleUrls: ['./slider-ticks-labels.component.scss']
})
export class SliderTicksLabelsComponent implements OnInit {

  @Input() question: SliderQuestion;
  @Input() form: FormGroup;

  showLabels = SHOW_LABELS;
  showTicks = SHOW_TICKS;
  showTrack = SHOW_TRACK;

  labels = [];
  getLabels: any;

  ngOnInit() {
    this.getLabels = getLabels;
    this.showLabels = this.question.options['showLabels'] ? SHOW_LABELS : HIDE_LABELS;
    this.showTicks = this.question.options['showTicks'] ? SHOW_TICKS : HIDE_TICKS;
    this.showTrack = this.question.options['showTrack'] ? SHOW_TRACK : HIDE_TRACK;
    this.labels = this.getLabels(this.question.options['labels']);
    this.configOnlyForHeightAndWeight(this.form.get('myHeight').value, this.form.get('myWeight').value);

    this.form.valueChanges.subscribe(values => {
      this.configOnlyForHeightAndWeight(values.myHeight, values.myWeight);
    });
  }

  configOnlyForHeightAndWeight(height: number, weight: number) {
    switch (this.question.key) {
      case 'myHeight':
        this.labels[0].content = `${height}cm`;
        break;
      case 'myWeight':
        this.labels[0].content = `${weight}kg`;
        break;
      default: break;
    }
  }
}

function getLabels(labels = []) {
  const result = [];
  if (labels.length === 1) {
    result.push({
      classesName: 'label2 col-xs-12',
      content: labels[0].content,
      colorClass: `label-${labels[0].color}`
    });
  }

  if (labels.length === 2) {
    result.push({
      classesName: 'label1 col-xs-6',
      content: labels[0].content,
      colorClass: `label-${labels[0].color}`
    });
    result.push({
      classesName: 'label2 col-xs-6',
      content: labels[1].content,
      colorClass: `label-${labels[1].color}`
    });
  }

  if (labels.length === 3) {
    result.push({
      classesName: 'label1 col-xs-6',
      content: labels[0],
      colorClass: `label-${labels[0].color}`
    });
    result.push({
      classesName: 'middle-label col-xs-6',
      content: labels[1],
      colorClass: `label-${labels[1].color}`
    });
    result.push({
      classesName: 'label2 col-xs-6',
      content: labels[2],
      colorClass: `label-${labels[2].color}`
    });
  }

  return result;
}



// WEBPACK FOOTER //
// ./src/app/shared/slider/slider-ticks-labels/slider-ticks-labels.component.ts